/**
 * Reviewer profile API (IAM service)
 */

import apiClient from './auth';

export interface ReviewerProfile {
  reviewer_uuid: string;
  primary_expertise: string[];
  secondary_expertise?: string[];
  years_experience: number;
  industry_background?: string | null;
  geographic_focus?: string[] | null;
  languages?: string[] | null;
  assessment_volume?: string | null;
  availability_status?: string | null;
  max_assignments?: number;
  current_assignments?: number;
  conflicted_institutions?: string[] | null;
  profile_completed?: boolean;
  bio?: string | null;
  created_at?: string;
  updated_at?: string;
}

export const EXPERTISE_OPTIONS = [
  'IoT',
  'AI/ML',
  'Biotech',
  'Fintech',
  'Agritech',
  'Clean Energy',
  'Manufacturing',
  'Healthcare',
  'Education',
  'Other',
];

export const INDUSTRY_BACKGROUNDS = ['Academia', 'Industry', 'Consulting', 'Government', 'NGO', 'Hybrid'];
export const ASSESSMENT_VOLUMES = ['Light', 'Moderate', 'Heavy'];
export const AVAILABILITY_OPTIONS = ['Full-time', 'Part-time', 'Occasional'];
export const GEOGRAPHIC_OPTIONS = ['Kenya', 'Uganda', 'Tanzania', 'East Africa', 'Africa-wide', 'Global'];
export const LANGUAGE_OPTIONS = ['English', 'Swahili', 'French', 'Other'];

export async function getReviewerProfile(): Promise<{ profile: ReviewerProfile }> {
  const response = await apiClient.get<{ profile: ReviewerProfile }>('/reviewers/profile');
  return response.data;
}

export interface CompleteProfileData {
  primary_expertise: string[];
  secondary_expertise?: string[];
  years_experience: number;
  industry_background?: string;
  geographic_focus?: string[];
  languages?: string[];
  assessment_volume: string;
  availability_status?: string;
  conflicted_institutions?: string[];
  bio?: string;
}

export async function completeProfile(data: CompleteProfileData): Promise<{ message: string; profile_completed: boolean }> {
  const response = await apiClient.post<{ message: string; profile_completed: boolean }>('/reviewers/complete-profile', data);
  return response.data;
}

export async function updateProfile(data: Partial<CompleteProfileData>): Promise<{ message: string }> {
  const response = await apiClient.put<{ message: string }>('/reviewers/profile', data);
  return response.data;
}
